export default __webpack_public_path__ + "static/media/CNo.68-3.9b882b24.jpg";